import React from 'react';

const Checkbox = ({
  id,
  children,
  disabled = false,
  checked = false,
  onChange = () => {},
  ...props
}) => {
  return (
    <label htmlFor={id}>
      <input
        type="checkbox"
        disabled={disabled}
        id={id}
        checked={checked ? 'checked' : ''}
        onChange={onChange}
        {...props}
      />
      <span className="u-s-ml-small">{children}</span>
    </label>
  );
};

export default Checkbox;
